const translations = {
  'homepage.seo.title': 'Los mejores cursos TEFL en Barcelona y Sevilla | Trinity CertTESOL',
  'homepage.seo.description':
    'Los mejores cursos TEFL en Barcelona, España, TEFL Iberia. Aplica online. ¡160 horas por tan solo € 1500 con un descuento por reserva anticipada!',
  'homepage.sec1.title': '¡Certificate como Docente Internacional de Inglés!',
  'homepage.sec1.description':
    'Matricúlate en TEFL Iberia y comienza tu formación en Barcelona.',
  'homepage.sec2.title': 'TEFL IBERIA ESTÁ AFILIADO A ',
  'homepage.sec3.title': 'En TEFL Iberia Te Preparamos Para el Éxito. Así es cómo',
  'homepage.sec3.ben1.title': ' Certificación Internacional reconocida',
  'homepage.sec3.ben1.text':
    '¿Barcelona? ¿Bangkok? ¿Brasil? Trinity CertTESOL está acreditada en todo el mundo',
  'homepage.sec3.ben2.title': 'Fomento de la confianza en el aula',
  'homepage.sec3.ben2.text': 'Porque enseñar inglés implica algo más que dominar el material.',
  'homepage.sec3.ben3.title': 'Asegura tu futuro laboral',
  'homepage.sec3.ben3.text':
    'Trabajamos arduamente para garantizar que todos nuestros estudiantes encuentren un trabajo relevante después de graduarse.',
  'homepage.sec3.ben4.title': 'Estilos de aprendizaje',
  'homepage.sec3.ben4.text':
    'Adaptamos nuestras clases a las necesidades individuales de nuestros estudiantes, asegurando una experiencia de aprendizaje efectiva y enriquecedora',
  'homepage.sec3.ben5.title': 'Grupos pequeños',
  'homepage.sec3.ben5.text':
    'Con un máximo de 12 estudiantes en clase, garantizamos que todos tengan acceso directo a su tutor',
  'homepage.sec5.title':
    '¡Ayudamos a miles de estudiantes a convertirse en profesores de inglés <accent> y tú podrías ser el siguiente!</accent>',
  'homepage.sec5.description':
    'Estudiantes de toda Latinoamérica vienen a formarse con TEFL Iberia, ilusionados por experimentar la aventura de vivir en España, con la oportunidad de trabajar y vivir en el exterior con la seguridad de un futuro laboral prometedor en un sector con un gran crecimiento.',
  'homepage.sec5.i1.title': '1000+',
  'homepage.sec5.i1.text': 'Historias de éxito estudiantil desde 2012',
  'homepage.sec5.i2.title': '60+',
  'homepage.sec5.i2.text': 'Nacionalidades representadas por nuestros antiguos alumnos',
  'homepage.sec5.i3.title': '20%',
  'homepage.sec5.i3.text': 'De nuestros alumnos no son hablantes nativos',
  'homepage.sec6.title': '¿Tienes preguntas? ¡Pregúntanos lo que quieras!',
  'homepage.sec6.downloadBrochure': 'Descarga nuestro folleto',
  'homepage.sec7.title': '¡Siempre estarás en buenas manos!',
  'homepage.sec7.description':
    'TEFL Iberia es mucho más que una escuela de formación. Nuestro maravilloso equipo de coordinadores te ayudará con alojamiento, visados, trámites burocráticos y mucho más.',
  'homepage.sec7.i1.title': 'Alojamiento',
  'homepage.sec7.i1.text':
    'Queremos que tu tiempo en Barcelona sea memorable dentro y fuera del aula. Por eso, te ubicamos en alojamiento con otros estudiantes de tu curso o recién graduados.',
  'homepage.sec7.i2.title': 'Visados de estudiante',
  'homepage.sec7.i2.text':
    '¿Necesitas ayuda para entender los requisitos de visa de estudiante en España y facilitar tu proceso de solicitud?  El equipo de TEFL Iberia siempre está disponible para ayudarte',
  'homepage.sec7.i3.title': 'Asesoría profesional',
  'homepage.sec7.i3.text':
    'Encuentra el trabajo de tus sueños con TEFL Iberia. Nuestros tutores tienen más de 30 años de experiencia internacional combinada y han construido una red de contactos de clase mundial.',
  'homepage.sec7.i.findOutMore': 'Más información',
  'homepage.sec8.title': 'Lo último de nuestro blog',
  'homepage.sec8.seeAllPosts': 'Ver próximas fechas',
  'homepage.sec9.title': '¿Listo para comenzar tu <accent>nueva carrera?</accent>',
  'homepage.sec9.description':
    'Ahora es más fácil que nunca convertirse en profesor/a internacional de inglés. Aplica ahora y comienza a trabajar en el empleo de tus sueños.',
};

export default translations;
